import { cn } from '@civilgrid/ui/utils';
import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

export interface Item {
  value: string;
  label: ReactNode;
}

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  items: Item[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const Radio = forwardRef<HTMLInputElement, Props>(({ value, items, disabled, className, ...props }, ref) => {
  const els = items.map(({ label, value: itemValue }) => {
    const uniqueId = `${label}/${itemValue}`;
    return (
      <div className="flex items-center gap-2 font-noto" key={uniqueId}>
        <input
          ref={ref}
          {...props}
          type="radio"
          id={uniqueId}
          checked={itemValue === value}
          onChange={() => props.onChange?.(itemValue)}
        />
        <label className="text-xs capitalize text-primary leading-snug" htmlFor={uniqueId}>
          {label}
        </label>
      </div>
    );
  });
  return <div className={cn('flex flex-col gap-1', className)}>{els}</div>;
});

export default Radio;
